import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../../services/spinner.service';
import { KidintLessonCard } from '../../../../interfaces/kidintlesson-card.interface';
import { ApiV2Service } from '../../../../services/api-v2.service';
import { AuthService } from '../../../../services/auth.service';
import { map } from 'rxjs/operators';
import { MessagesModalService } from '../../../../services/messages-modal.service';
import { plananualchilepb } from 'src/app/mocks/plananual-chile-pb';

@Component({
  selector: 'app-partnerlessons-card',
  templateUrl: './partnerlessons-card.component.html',
  styleUrls: ['./partnerlessons-card.component.css'],
})
export class PartnerlessonsCardComponent implements OnInit {
  scaleCard: string;
  cardSizeScaled: number;
  canEdit: boolean;
  canDelete: boolean;
  actCount: number;

  @Input() cardSize: number;
  @Input() partnerLessonCard: KidintLessonCard;
  @Output('reload') deleteLesson: EventEmitter<any> = new EventEmitter();
  //@Output() monthSelected = new EventEmitter<number>();

  constructor(
    private api: ApiV2Service,
    private router: Router,
    private spinner: SpinnerService,
    private auth: AuthService,
    private message: MessagesModalService
  ) {}

  ngOnInit(): void {
    //console.log(this.partnerLessonCard)
  }

  goToInfo() {
    if (this.partnerLessonCard.owner != undefined) {
      if (this.partnerLessonCard.owner.id === this.auth.currentUser.id) {
        console.log(this.partnerLessonCard.id);
        this.router.navigate([
          '/lessons/public-activities',
          this.partnerLessonCard.id,
          true,
        ]);
      } else {
        console.log(this.partnerLessonCard.id);
        const params = {
          name: this.partnerLessonCard.name,
          description: this.partnerLessonCard.description,
          category: this.partnerLessonCard.category,
          //usr:this.partnerLessonCard.owner.id
        };
        console.log('params', params);
        this.router.navigate(
          ['/lessons/public-activities', this.partnerLessonCard.id, true],
          { queryParams: params }
        );
      }
    }
    else{
        const params = {
          name: this.partnerLessonCard.name,
          description: this.partnerLessonCard.description,
          category: this.partnerLessonCard.category,
          //usr:this.partnerLessonCard.owner.id
        };
        console.log('params', params);
        this.router.navigate(
          ['/lessons/public-activities', this.partnerLessonCard.id, true],
          { queryParams: params }
        );
      
    }
  }
}
